import React, { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { MarginProps } from '../../../../../theme/styledProps';
import { FormValues } from '../../FirmSettings.meta';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { useFeatureFlag } from '../../../../../_hooks/useFeatureFlag';
import { Feature } from '../../../../../CommonSelectors/CommonArea.types';
import { TermsModal } from './components/TermsModal/TermsModal';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const BeFi20: React.FC<Props> = ({ formBag, ...rest }) => {
  const showBeFi20 = useFeatureFlag(Feature.BeFi20);

  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  if (!showBeFi20) {
    return null;
  }

  const allowBeFi20 = formBag.watch('allowBeFi20');

  return (
    <>
      <Box as="section" {...rest}>
        <SectionHeader title="BeFi20" />

        <Toggle
          checked={allowBeFi20}
          onChange={evt => {
            if (evt.target.checked) {
              setIsTermsModalOpen(true);
            } else {
              formBag.setValue('allowBeFi20', false, { shouldDirty: true });
            }
          }}
          helperText={
            allowBeFi20 ? (
              <>
                I’ve read and accepted the{' '}
                <Button
                  variant="link"
                  size="small"
                  onClick={() => setIsTermsModalOpen(true)}
                  ml={2}
                >
                  Orion BeFi20 Services Agreement
                </Button>
              </>
            ) : (
              ''
            )
          }
          mt="24"
        >
          Allow Advisors to Access BeFi20
        </Toggle>
      </Box>

      {isTermsModalOpen && (
        <TermsModal
          onClose={() => {
            setIsTermsModalOpen(false);
            formBag.setValue('allowBeFi20', false, { shouldDirty: true });
          }}
          onAccept={() => {
            setIsTermsModalOpen(false);
            formBag.setValue('allowBeFi20', true, { shouldDirty: true });
            formBag.setValue('hasAcceptedBeFi20Terms', true, { shouldDirty: true });
          }}
        />
      )}
    </>
  );
};
